export default {
  default: {
    buttons: {
      minimize: 'Minimize',
      showCompleted: 'Show Completed',
    },
  },
}
